import { Route } from '@angular/router';

import { AnnouncementsOverviewPage } from './announcements-overview-page/announcements-overview-page';
import { CreateAnnouncementPage } from './create-announcement-page/create-announcement-page';
import { EditAnnouncementPage } from './edit-announcement-page/edit-announcement-page';

export const announcementRoutes: Route[] = [
  {
    path: '',
    component: AnnouncementsOverviewPage,
    data: {
      title: 'announcement.page.title',
      breadcrumb: 'navigation.announcements',
    },
  },
  {
    path: 'new',
    component: CreateAnnouncementPage,
    data: {
      title: 'announcement.create.title',
      breadcrumb: 'navigation.announcements',
    },
  },
  {
    path: 'edit/:id',
    component: EditAnnouncementPage,
    data: {
      title: 'announcement.edit.title',
      breadcrumb: 'navigation.announcements',
    },
  },
  { path: 'edit', redirectTo: '', pathMatch: 'full' },
];
